<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Content from '@/services/Content'
    import Swal from "sweetalert2";
    import modalAddBusinessNews from "@/components/modals/business/modalAddBusinessNews";
    import modalEditBusinessNews from "@/components/modals/business/modalEditBusinessNews";

    export default {
        components: { Layout, PageHeader, modalAddBusinessNews,modalEditBusinessNews},
        page: {
            title: "Business News",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "News Business",
                items: [
                    {
                        text: "News",
                    },
                    {
                        text: "News Business",
                        active: true,
                        href: "/news/feed",
                    },
                ],
                showRefresh:true,
                showAlert: false,
                isBusyButton: false,
                isBusy: false,
                error: null,
                showModal:false,
                modalData:{},
                link_id:null,
                tableData: [],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "published",
                sortDesc: true,
                originalTableData: [],
                active: true,
                fields: [
                    {
                        key: "title",
                        label: "Title",
                        sortable: true,
                    },
                    {
                        key: "image",
                        label: "Image",
                        sortable: false,
                    },
                    {
                      key: "link",
                      label: "Link",
                      sortable: false,
                    },
                    {
                        key: "published",
                        label: "Published Date",
                        sortable: true,
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: false,
                    },
                    {
                        key: "active",
                        label: "Status",
                        sortable: true,
                    },
                    "action",
                ],
                 "refreshNewsBtn":false
            };
        },
        async created() {
            await this.getNews()
            this.refreshNewsBtn = await this.checkObjectAccessCall('button.news.refresh');
        },
        methods: {

            modalAddBusinessNews() {
                this.$bvModal.show("add_business_news");
            },
            callModalBusinessNewsEdit(data) {
                this.$bvModal.show("news_edit");
                this.modalData = data;
                console.log("Opening modal with data:", data);
            },

            async getNews(){
                try {
                    this.toggleBusy();
                    const response = await Content.getBusinessNews(1000,'all','news', 'all', 1)
                    this.originalTableData = response.data.news
                    this.applyFilters()
                    this.toggleBusy();
                } catch (error) {
                    this.toggleBusy();
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },

            removeNews(id) {
              Swal.fire({
                  title: "Remove business news article?",
                  text: "This business news article will be removed!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  confirmButtonText: "Remove!",
              }).then(async (result) => {
                  if (result.value) {
                      try {
                          const response = await Content.deleteBusinessNews(id);
                          if (response.data) {
                              this.successmsg("Remove Business News", "Business News is successfully removed!");
                              await this.getNews()
                          } else {
                              const error = response.data.error || "Failed";
                              this.failedmsg(error);
                          }
                      } catch (error) {
                          this.error = error.response?.data?.error || "An error occurred";
                          this.failedmsg(this.error);
                      }
                  }
              });
            },

            restoreNews(source_id){
                Swal.fire({
                    title: "Restore Business news article?",
                    text: "This Business news article will be restored!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Restore!",
                }).then((result) => {
                    if (result.value) {
                        try {
                            Content.restoreBusinessNews(source_id)
                                .then((response) => {
                                    const res = response.data ? response.data : false;
                                    const error = response.data.error ? response.data.error : 'Failed';
                                    if(res){
                                        this.successmsg("Restore Business news", "Business News article is successfully restored!");
                                        this.getNews()
                                    }else{
                                        this.failedmsg(error);
                                    }
                                })
                        }catch(error){
                            this.error = error.response.data.error ? error.response.data.error : "";
                        }
                    }
                });
            },

            applyFilters() {
                if (this.active === true) {
                    // only active news
                    this.tableData = this.originalTableData.filter(item => item.active === 1);
                } else if (this.active === false) {
                    // only inactive news
                    this.tableData = this.originalTableData.filter(item => item.active === 0);
                } else {
                    // fallback: show all
                    this.tableData = this.originalTableData;
                }

                this.totalRows = this.tableData.length;
            },

            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                       <div class="row mb-0">
                            <div  class="col-12">
                                <a href="javascript:void(0);" :disabled=isBusyButton class="btn btn-success waves-effect waves-light text-end" @click="modalAddBusinessNews()">
                                    <span v-if="!isBusyButton"><i class="mdi mdi-plus me-2"></i>Add Business News</span>
                                    <span v-else>Loading...</span>
                                </a>
                            </div>
                        </div>
                        <h4 class="card-title">Total News: {{totalRows}}</h4>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-3">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="d-flex align-items-center">
                                    <label class="me-3 mb-0" for="newsStatus">Inactive News</label>

                                    <div class="form-check form-switch form-switch-lg mb-0">
                                        <input v-model="active"
                                               @change="applyFilters"
                                               type="checkbox"
                                               class="form-check-input"
                                               id="newsStatus" />
                                    </div>
                                    <label class="mb-0" for="newsStatus">Active News</label>
                                </div>
                            </div>

                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >
                                <template v-slot:cell(title)="data">
                                    <div>
                                        <span>{{data.item.title}}</span>
                                        <span class="badge bg-danger ms-2" style="font-size:12px;" v-if="data.item.deleted === 1">deleted</span>
                                    </div>
                                </template>
                                <template v-slot:cell(link)="data">
                                    <a v-if="data.item.link" :href="data.item.link" target="_blank">{{data.item.link.slice(0, 80)}}...</a>
                                </template>
                                <template v-slot:cell(image)="data">
                                    <div class="flex-shrink-0">
                                        <img v-if="data.item.image" class="img-fluid table-images" :src="`${data.item.image}?ts=${Date.now()}`">
                                    </div>
                                </template>
                                <template v-slot:cell(active)="data">
                                  <span :class="{'text-success': data.item.active === 1, 'text-danger': data.item.active === 0}">
                                    {{ data.item.active === 1 ? 'Active' : 'Inactive' }}
                                  </span>
                                </template>
                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0 d-flex align-items-center">
                                        <li v-if="data.item.deleted === 0" class="list-inline-item">
                                            <a
                                                    href="javascript:void(0);"
                                                    class="text-danger"
                                                    title="Remove Business News"
                                                    @click="removeNews(data.item.id)">
                                                <i class="uil uil-trash-alt font-size-18"></i>
                                            </a>
                                        </li>
                                        <li v-if="data.item.deleted === 1" class="list-inline-item">
                                            <a href="javascript:void(0);" class=" text-danger" title="Restore Business News" @click="restoreNews(data.item.source_id)">
                                                <i class="fas fa-trash-restore-alt font-size-15"></i>
                                            </a>
                                        </li>
                                        <li v-if="data.item.type !== 'rss'" class="list-inline-item" >
                                            <a
                                                    href="javascript:void(0);"
                                                    class="px-2 text-primary"
                                                    title="Edit Business News"
                                                    @click="callModalBusinessNewsEdit(data.item)"
                                            >
                                                <i class="uil uil-pen font-size-18"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </template>
                                 <template #table-busy>
                                                <div class="text-center text-danger my-2">
                                                     <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

   <!-- MODALS -->
      <modalAddBusinessNews  @refreshScreen="getNews"></modalAddBusinessNews>
      <modalEditBusinessNews :data="modalData"  @onRefresh="getNews">
      </modalEditBusinessNews>
      <!-- END  MODALS -->
    </Layout>
</template>